import { ForumUser } from "@/app/models/forum/new-forum.model"
import { NewForumActions } from "../actions/new-forum"
import {NewActivityCreationActions} from "@redux/actions/activity-creation";

export const NEW_FORUM_REDUCER_NAMESPACE = 'newForumReducer'

export interface NewForumState {
    storeList: {store_id: string}[]
    userList: ForumUser[]
    smartFilter: any
}

const defaultstate = {
    storeList: [],
    userList: [],
    smartFilter: {}
}

export default (state = defaultstate, action) => {
    switch (action.type) {
        case NewForumActions.SET_STORE_LIST: {
            return {
                ...state,
                storeList: action.storeList
            }
        }
        case NewForumActions.SET_USER_LIST: {
            return {
                ...state,
                userList: action.userList
            }
        }
        case NewActivityCreationActions.SET_SMART_FILTER:
            return {
                ...state,
                smartFilter: action.value,
            }
        default:
            return state
    }
}
